import { render, staticRenderFns } from "./inquiryShipping.vue?vue&type=template&id=c9db72d2&scoped=true"
import script from "./inquiryShipping.vue?vue&type=script&lang=js"
export * from "./inquiryShipping.vue?vue&type=script&lang=js"
import style0 from "./inquiryShipping.vue?vue&type=style&index=0&id=c9db72d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9db72d2",
  null
  
)

export default component.exports